import React from 'react';
import PropTypes from 'prop-types';
import { compose, withStateHandlers } from 'recompose';
import { Paragraph, Expand } from 'components/atoms';
import './ReadMoreButton.scss';

export const enhance = compose(
	withStateHandlers(
		{ expanded: false },
		{
			handleToggle:
				({ expanded }) =>
				() => ({
					expanded: !expanded,
				}),
		}
	)
);

export const ReadMoreButton = ({ expanded, handleToggle, children }) => (
	<div className="read-more">
		<Expand
			showing={expanded}
			showTeaser={true}
		>
			<div className="read-more-content">{children}</div>
		</Expand>
		<button
			onClick={() => {
				handleToggle();
			}}
			className="read-more-toggle"
		>
			<Paragraph
				size="tall"
				color="gray"
			>
				{expanded ? ' - Read Less' : ' + Read More'}
			</Paragraph>
		</button>
	</div>
);

ReadMoreButton.propTypes = {
	children: PropTypes.node.isRequired,
	expanded: PropTypes.bool.isRequired,
	handleToggle: PropTypes.func.isRequired,
};

ReadMoreButton.defaultProps = {
	expanded: false,
};

export default enhance(ReadMoreButton);
